import axios from 'axios'
import Utils from '@/common/Utils'
import store from '../store'

const headers = { 'Content-Type': 'application/json' }
const baseUrl = `${process.env.VUE_APP_HOST || ''}/credits/api-external`

export default class CreditsManagerService {
    static async getAll (endpoint, params) {
        try {
            headers['Authorization'] = await Utils.setCreditsManagerToken()
            let { data } = await axios.get(`${baseUrl}${endpoint}`, { headers, params, withCredentials: false })
            return data
        } catch (error) {
            throw new Error(error.response)
        }
    }

    static async getOne (endpoint, id, params = {}) {
        try {
            headers['Authorization'] = await Utils.setCreditsManagerToken()
            let { data } = await axios.get(`${baseUrl}${endpoint}${id}`, { headers, params, withCredentials: false })
            return data
        } catch (error) {
            throw new Error(error.response)
        }
    }

    static async update (endpoint, id, params = {}) {
        try {
            headers['Authorization'] = await Utils.setCreditsManagerToken()
            let { data } = await axios.put(`${baseUrl}${endpoint}${id}`, params, { headers, withCredentials: false })
            return data
        } catch (error) {
            throw new Error(error.response)
        }
    }

    static async create (endpoint, params = {}) {
        try {
            headers['Authorization'] = await Utils.setCreditsManagerToken()
            let { data } = await axios.post(`${baseUrl}${endpoint}`, params, { headers, withCredentials: false })
            return data
        } catch (error) {
            throw new Error(error.response)
        }
    }

    static async executeAction (endpoint, actionData = {}) {
        try {
            headers['Authorization'] = await Utils.setCreditsManagerToken()
            actionData.username = store.getters.user ? store.getters.user.userName : 'Desconocido'
            actionData.userId = store.getters.user ? store.getters.user.userId : null
            let { data } = await axios.put(`${baseUrl}${endpoint}`, JSON.stringify(actionData), { headers, withCredentials: false })
            return data
        } catch (error) {
            throw new Error(error.response)
        }
    }
}
